
const loginAPI = 'https://mbd.baidu.com/newspage/api/getusername';

export {
    loginAPI
};